// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".intro[data-v-9264f4fe]{margin-top:24px}.page__header[data-v-9264f4fe]{position:relative}.page__header .set-sticky[data-v-9264f4fe]{position:absolute;left:0;right:0;top:0;height:calc(100% - 100px);z-index:-1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
